import { isReadOnly, isRegionalManager, isZonalManager } from '@/common';
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      isReadOnly: false
    };
  },
  created() {
    this.checkReadOnlyAccess();
  },
  activated() {
    this.checkReadOnlyAccess();
  },
  methods: {
    checkReadOnlyAccess() {
      this.isReadOnly = isReadOnly() || isRegionalManager() || isZonalManager();
    }
  }
});